<div class="category-section">
  <div class="container">
    <app-breadcrumb [breadcrumbs]="currentBreadcrumb"></app-breadcrumb>
    <div class="stacked-container d-flex justify-content-start py-3 main">
      <div class="image-stack d-lg-block d-none" *ngIf="this.currentCategory?.imageURL">
        <img class="bg-img" src="images/product-1.png" alt="Background 1" />
        <img class="bg-img" src="images/product-2.png" alt="Background 2" />
        <img [src]="this.currentCategory?.imageURL" alt="Main Image" />
      </div>
      <div class="stacked-title">
        <h5>{{ this.currentCategory?.categoryName }}</h5>
      </div>
    </div>
    <div class="list">
      <a class="card" [routerLink]="getCategoryUrl(item)" *ngFor="let item of category">
        <div class="image">
          <img [src]="item.imageURL || 'placeholder.svg'" alt="" height="250" width="250" />
        </div>
        <p>{{ item.categoryName.length<25? item.categoryName: item.categoryName.slice(0,25)+'... '  }}</p>
      </a>
    </div>
    <!-- <div  *ngIf="user?.firstName">
            <app-recent-view></app-recent-view>
        </div> -->
  </div>
</div>